export default {
    name: 'serve-not-found',
}
